import React from "react";
import {
    Container,
    IconContainer,
    CreditContainer,
    BalanceContainer,
    BalanceRow,
    BalanceText,
    StyledClearIcon,
    StyledMoneyIcon,
    IconTextFlex,
    StyledCurrencyExchangeIcon,
    BottomLine,
} from "./credit-limit.styled";
import { getDisplayBenefits } from "@/helper/displayBenefits";
import amountToFixed from "@/helper/amountToFixed";

const colorMap = {
    "Límite de Crédito": "#6ec4e8",
    Asignación: "#fd8d68",
};

export default function CreditLimit({ balances, close, giftCards }) {
    const displayBenefits = getDisplayBenefits(balances ?? [], giftCards);

    return (
        <Container>
            <IconContainer>
                <StyledClearIcon onClick={close} />
            </IconContainer>
            {displayBenefits.map((balance) => (
                <BottomLine key={balance.id ?? balance.name}>
                    {" "}
                    <CreditContainer color={colorMap[balance.name] || "#fd8d68"}>
                        <IconTextFlex>
                            {balance.name === "Límite de Crédito" ? (
                                <StyledCurrencyExchangeIcon />
                            ) : balance.name === "Asignación" ? (
                                <StyledMoneyIcon />
                            ) : (
                                <StyledCurrencyExchangeIcon />
                            )}
                            <div>{balance.name}</div>
                        </IconTextFlex>
                        <BalanceContainer>
                            {balance.balances?.map((balance) => (
                                <BalanceRow key={balance.name}>
                                    <BalanceText>{balance.name}</BalanceText>
                                    <BalanceText>
                                        <strong>{`RD$ ${amountToFixed(balance.amount, 2)}`}</strong>
                                    </BalanceText>
                                </BalanceRow>
                            ))}
                        </BalanceContainer>
                    </CreditContainer>
                </BottomLine>
            ))}
        </Container>
    );
};
